import { render, staticRenderFns } from "./credit-and-transaction-managment.vue?vue&type=template&id=23187a72"
import script from "./credit-and-transaction-managment.vue?vue&type=script&lang=js"
export * from "./credit-and-transaction-managment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports